
function showTranscriptModal() {
    
    const transcriptModal = document.getElementById('transcriptModal');
    const transcriptModalShow = document.getElementById('podcast__player--transcript');
    const transcriptCloseSpan = document.getElementsByClassName("transcript-modal__container-close")[0];

    const checkTranscriptModal = document.body.contains(transcriptModal);

    if (checkTranscriptModal) {
        transcriptModalShow.onclick = function() {
            transcriptModal.style.display = "block";
        }
        transcriptCloseSpan.onclick= function() {
            transcriptModal.style.display = "none";
        }
        window.onclick = function(event) {
            if (event.target == transcriptModal) {
                transcriptModal.style.display = "none";
            }
        }
    }
    else {
        // console.log('Hide Transcript Modal');
    }
}

showTranscriptModal();
